const cardTheme = {
  baseStyle: {
    container: {
      borderRadius: "28px",
      borderWidth: "1px",
      borderColor: "surface.border",
      bg: "surface.card",
      boxShadow: "0 18px 38px rgba(15, 23, 42, 0.08)",
    },
  },
};

export default cardTheme;
